// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, styled, Tooltip, tooltipClasses, Typography } from '@mui/material'

// **Style Imports
import './CustomFeedbackTooltip.scss'

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 420,
    minWidth: 350,
    fontSize: theme.typography.pxToRem(12),
    padding: '0',
    backgroundColor: 'transparent',
    boxShadow: `rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px`
  },
  [`& .${tooltipClasses.popper}`]: {
    zIndex: 1400
  }
}))

const CustomFeedbackTooltip = ({
  title = 'Rejection Feedback',
  feedback = '',
  feedbackBy = '',
  status = '',
  children
}) => {
  return (
    <HtmlTooltip
      arrow
      placement="top"
      title={
        <Box className="feedback-tooltip-container">
          <Box className="feedback-tooltip-title">
            {title}{' '}
            {(feedbackBy || status) && (
              <Typography
                component={'span'}
                variant="body2"
                sx={{
                  textAlign: 'right',
                  color: 'var(--grey-200)',
                  fontSize: '12px',
                  fontWeight: '700'
                }}
              >
                {feedbackBy ? `- by ${feedbackBy}` : status}
              </Typography>
            )}
          </Box>
          <Box className="feedback-tooltip-content">
            {feedback && (
              <Typography
                sx={{
                  fontSize: '13px',
                  color: 'var(--grey-600)'
                }}
              >
                {feedback}
              </Typography>
            )}
          </Box>
        </Box>
      }
    >
      <Box sx={{ display: 'inline-flex', cursor: 'pointer' }}>{children}</Box>
    </HtmlTooltip>
  )
}

export default memo(CustomFeedbackTooltip)
